import React from 'react'
import { Tooltip, Chip } from '@mui/material'

const ChipStatus = React.forwardRef(({ status, color, bgcolor, height = 24, fontSize = 10, isUppercase = true, borderRadius = '50px', ...props }, ref) => {
  return (
    <Chip
      {...props}
      ref={ref}
      size="small"
      label={isUppercase ? status.toString().toUpperCase() : status.toString()}
      sx={{
        borderRadius: borderRadius,
        backgroundColor: bgcolor ?? '#E7E7E7',
        color: color ?? '#5D5D5D',
        fontWeight: 500,
        fontSize: fontSize,
        height: height,
        lineHeight: `${height}px`,
        '& .MuiChip-label': {
          color: color ?? '#5D5D5D',
        },
        ...props.sx
      }}
    />
  )
})

const Status = ({ status, color, bgcolor, height = 24, fontSize = 10, tooltip = '', isUppercase = true, borderRadius = '50px', ...props }) => {
  return tooltip ? (
    <Tooltip title={tooltip} placement={'top'} arrow>
      <ChipStatus 
        status={status} 
        color={color} 
        bgcolor={bgcolor} 
        height={height} 
        fontSize={fontSize} 
        isUppercase={isUppercase}
        borderRadius={borderRadius}
        {...props}
      />
    </Tooltip>
  ) : (
    <ChipStatus 
      status={status} 
      color={color} 
      bgcolor={bgcolor} 
      height={height} 
      fontSize={fontSize} 
      isUppercase={isUppercase}
      borderRadius={borderRadius}
      {...props}
    />
  )
}

export default Status